<script setup lang="ts">
function onDismiss() {
  useModal().close();
}
</script>

<template>
  <CommonGenericModalContainer :ui="{ width: 'sm:max-w-4xl' }">
    <template #header>
      <CommonGenericModalHeader
        title-key="Privacy Policy for Fight Search"
        :on-dismiss="onDismiss"
      />
    </template>

    <LegalPrivacyPolicyContent />
  </CommonGenericModalContainer>
</template>
